/* eslint-disable object-shorthand */
import axios from 'axios/index'

import config from '../../config'
import action, { actionFailed } from '../../util/action'
import createAsyncConst from '../../util/createAsyncConst'

export const FETCH_DRE = createAsyncConst('FETCH_DRE')
